import { useCallback } from 'react';

import { ROUTES } from '@/shared/config/constants';
import { twa } from '@/shared/lib/telegram/twa';

export const useFooterNavigation = () => {
  const handleTabClick = useCallback((tabId: string, isAlreadyActive: boolean) => {
    twa.hapticFeedback.impactOccurred('light');

    if (isAlreadyActive && tabId === ROUTES.GAMES) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }, []);

  return { handleTabClick };
};
